import { useAuth } from "../contexts/AuthContext";
import { permissionsFactory } from "../utils/utils";
import Page403 from "./403";
import DataTableContainer from '../components/containers/DataTableContainer';
import StudentsTable from '../components/tables/StudentsTable';

const StudentsRegistered = () => {
  const { permissions } = useAuth();
  const grantedPermissions = permissionsFactory(permissions);
  if (!grantedPermissions.canViewStudent) {
    return <Page403 />;
  }
  
  return (
    <DataTableContainer>
      <div style={{height: '93vh'}}>
        <StudentsTable 
          tableConfig={{
            studentsPath: 'students/',
            year: '2026',
            title: 'Alunos registrados (Origem Sponte)',
            baseQueryParams:{},
            columns: {
              status: true
            },
            pageSize: 15,
            initialColumnFilters: [{id: 'status', value: 'active'}],
            columnVisibility: {
              external_id: false,
            }
          }}                                                      
        />
      </div>
    </DataTableContainer>
  );
};

export default StudentsRegistered;
